import React from "react"
import { connectRefinementList } from "react-instantsearch-dom"
import { updateInternalSearchSessionStorage } from "components/page-components/Internal-Search/utils"

export const ScopeMenu = connectRefinementList(
  ({ set_focussed, searchState, setSearchState, all_types }) => {
    const current_scope_refinement = searchState?.refinementList?.scope?.join()

    const choose_all = (e) => {
      e.preventDefault()
      updateInternalSearchSessionStorage({
        last_search_state: {
          ...searchState,
          refinementList: { scope: ["website", "notice"], type: all_types },
        },
        focussed: false,
      })
      setSearchState({
        ...searchState,
        refinementList: { scope: ["website", "notice"], type: all_types },
      })
      set_focussed(false)
    }

    const choose_website = (e) => {
      e.preventDefault()
      updateInternalSearchSessionStorage({
        last_search_state: {
          ...searchState,
          refinementList: {
            scope: ["website"],
            type: all_types.filter((type) => type !== "notice"),
          },
        },
        focussed: false,
      })
      setSearchState({
        ...searchState,
        refinementList: {
          scope: ["website"],
          type: all_types.filter((type) => type !== "notice"),
        },
      })
      set_focussed(false)
    }

    const choose_notice = (e) => {
      e.preventDefault()
      updateInternalSearchSessionStorage({
        last_search_state: {
          ...searchState,
          refinementList: { scope: ["notice"], type: ["notice"] },
        },
        focussed: true,
      })
      setSearchState({
        ...searchState,
        refinementList: { scope: ["notice"], type: ["notice"] },
      })
      set_focussed(true)
    }

    return (
      <div className="level-left">
        <a
          href={"# "}
          className="level-item has-text-white"
          onClick={choose_all}
          style={{
            borderBottom:
              !current_scope_refinement ||
              current_scope_refinement === "website,notice"
                ? "2px solid #ffd62e"
                : "2px solid transparent",
          }}
        >
          Alle
        </a>
        <a
          href={"# "}
          className="level-item has-text-white"
          onClick={choose_website}
          style={{
            borderBottom:
              current_scope_refinement === "website"
                ? "2px solid #ffd62e"
                : "2px solid transparent",
          }}
        >
          Webseite
        </a>
        <a
          href={"# "}
          className="level-item has-text-white"
          onClick={choose_notice}
          style={{
            borderBottom:
              current_scope_refinement === "notice"
                ? "2px solid #ffd62e"
                : "2px solid transparent",
          }}
        >
          Ausschreibungen
        </a>
      </div>
    )
  }
)
